/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";

import {COLORS} from "@res/colors";
import {CSSProperties} from "react";

type Props = {
	className?: string
	style?: CSSProperties
}

export class HLine
	extends React.Component<Props> {

	render() {
		return <div className={`match_width ${this.props.className || ''}`} style={{height: 1, backgroundColor: COLORS.neutral_gray_2, ...this.props.style}}/>
	}

}
